export default {
  35: {
    EU: 35,
    UK: 2,
    US: 5
  },
  36: {
    EU: 36,
    UK: 3,
    US: 6
  },
  37: {
    EU: 37,
    UK: 4,
    US: 7
  },
  38: {
    EU: 38,
    UK: 5,
    US: 8
  },
  39: {
    EU: 39,
    UK: 6,
    US: 9
  },
  40: {
    EU: 40,
    UK: 7,
    US: 10
  },
  41: {
    EU: 41,
    UK: 8,
    US: 11
  },
  42: {
    EU: 42,
    UK: 9,
    US: 12
  },
  43: {
    EU: 43,
    UK: 10,
    US: 13
  }
}
